<div class="warpper-question">
    <div class="warp-select">
        <select [formControl]="questionForm.controls.fromNum">
            <ng-container *ngFor="let num of numberRange">
                <option *ngIf="num<=(questionForm.controls.toNum.value??10)" [value]="num">{{ num }}</option>
            </ng-container>
        </select>
        <p translate>questionBoard.edit.range-until</p>
        <select [formControl]="questionForm.controls.toNum">
            <ng-container *ngFor="let num of numberRange">
                <option *ngIf="num>=(questionForm.controls.fromNum.value??10)" [value]="num">{{ num }}</option>
            </ng-container>
        </select>
    </div>
</div>